module.exports = __webpack_public_path__ + "static/media/pic_05.50782f0f.jpg";